var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex secondary white--text pa-4",style:(`width: ${_vm.width}`)},[_c('v-icon',{staticClass:"white--text mr-4",attrs:{"x-large":""}},[_vm._v(_vm._s(_vm.icon))]),_c('div',[_c('div',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('h2',[_vm._v(_vm._s(_vm.value))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }